import React from 'react'

interface Props {
  readonly autoplay?: boolean
  readonly centerMode?: boolean
  readonly centerPadding?: string
  readonly prevArrow?: string
  readonly nextArrow?: string
  readonly slidesToShow?: number
  readonly infinite?: boolean
  readonly slidesToScroll?: number
  readonly arrows?: boolean
  readonly responsive?: any
  readonly swipeToSlide?: boolean
  readonly touchThreshold?: number
}

class SlickCarousel extends React.Component<Props> {
  constructor(props) {
    super(props)
  }

  static defaultProps = {
    autoplay: false,
    centerMode: true,
    centerPadding: '0',
    prevArrow: '<i class="carousel-left far fa-chevron-left"></i>',
    nextArrow: '<i class="carousel-right far fa-chevron-right"></i>',
  }

  componentDidMount() {
    $('.slick-carousel')
      .not('.slick-initialized')
      .slick({
        ...this.props,
      })
      .each(function () {
        // Fix backwards swiping for infinite looping, see: https://github.com/kenwheeler/slick/issues/2002
        this['slick'].getNavigableIndexes = function () {
          let _ = this,
            breakPoint = 0,
            counter = 0,
            indexes: number[] = [],
            max

          if (_.options.infinite === false) {
            max = _.slideCount
          } else {
            breakPoint = _.options.slideCount * -1
            counter = _.options.slideCount * -1
            max = _.slideCount * 2
          }

          while (breakPoint < max) {
            indexes.push(breakPoint)
            breakPoint = counter + _.options.slidesToScroll
            counter +=
              _.options.slidesToScroll <= _.options.slidesToShow
                ? _.options.slidesToScroll
                : _.options.slidesToShow
          }

          return indexes
        }
      })
  }
  render() {
    return <div className='slick-carousel'>{this.props.children}</div>
  }
}

export default SlickCarousel
